
export default {
  components: {
    hotIsHotmartForMeForm: () => import('~/components/Organisms/IsHotmartForMeForm/IsHotmartForMeForm.vue'),
  },
}
